export default __webpack_public_path__ + "static/media/logo.6d9e2b1b.svg";